import { ChevronRight, Home } from "lucide-react";

// items: [{ label, onClick? }] — last item is the current page (not clickable)
export const Breadcrumbs = ({ items = [], onHome }) => (
  <nav aria-label="Breadcrumb" data-testid="breadcrumbs">
    <ol className="flex items-center gap-1 text-xs text-muted-foreground flex-wrap">
      <li>
        <button
          type="button"
          onClick={onHome}
          className="flex items-center gap-1 rounded px-1.5 py-0.5 hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring transition-colors"
          aria-label="Go to overview"
          data-testid="breadcrumb-home"
        >
          <Home className="w-3.5 h-3.5" />
        </button>
      </li>
      {items.map((it, i) => {
        const last = i === items.length - 1;
        return (
          <li key={`${it.label}-${i}`} className="flex items-center gap-1">
            <ChevronRight className="w-3.5 h-3.5 opacity-50" aria-hidden="true" />
            {last || !it.onClick ? (
              <span className={last ? "font-medium text-foreground" : ""} aria-current={last ? "page" : undefined}>{it.label}</span>
            ) : (
              <button type="button" onClick={it.onClick} className="rounded px-1 py-0.5 hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring transition-colors">{it.label}</button>
            )}
          </li>
        );
      })}
    </ol>
  </nav>
);
